<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-header>
        <ion-toolbar>
          <div class="d-flex ms-1 p-3 justify-content-between">
            <div class="d-flex flex-column ms-1">
              <img src="/assets/images/logo-new.png" alt="logo" width="80" />
              @if (isLoggedIn) {
              <p>{{profile.lastName}} {{profile.firstName}} ({{ profile.emailId }})</p>
              }
            </div>
            <div (click)="initMenuItems()">
              <div class="d-flex flex-column ms-1">
                <i class="fa-solid fa-arrows-rotate"></i>
              </div>
            </div>
          </div>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list id="inbox-list">
          <!-- <ion-list-header>EASIE</ion-list-header> -->
          <!-- @if (isLoggedIn) {
            <ion-note>{{profile.emailId}}</ion-note>
          } -->
          @if(menuItemsLoading) {
          <div style="display: flex; justify-content: center;">
            <ion-item lines="none">
              <i class="fa-solid fa-xl fa-circle-notch fa-spin"></i>
            </ion-item>
          </div>
          }
          @if(!menuItemsLoading) {
          <ion-accordion-group>
            @for (item of applicableMenuItems; track item; let i = $index) {
            @if (item.children && item.children.length > 0) {
            <ion-accordion (value)="(item.title)">
              <ion-item slot="header" color="light">
                <i class="{{ item.icon }}"></i> &nbsp;&nbsp;&nbsp;
                <ion-label>{{ item.title }}</ion-label>
              </ion-item>
              @for (child of item.children; track child; let j = $index) {
              <div slot="content">
                <ion-menu-toggle auto-hide="false">
                  <ion-item [routerLink]="child.url" class="submenu-item" routerLinkActive="selected" lines="none">
                    &nbsp;&nbsp;&nbsp;<i class="{{ child.icon }}"></i>
                    &nbsp;&nbsp;&nbsp;
                    <span> {{ child.title }}</span>
                  </ion-item>
                </ion-menu-toggle>
              </div>
              }
              <!--  -->
            </ion-accordion>
            } @if (!item.children) {
            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" [routerLink]="[item.url]" lines="none" detail="false"
                routerLinkActive="selected">
                <i class="{{ item.icon }}"></i> &nbsp;&nbsp;&nbsp;
                <ion-label>{{ item.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            }
            }
          </ion-accordion-group>
          }

          <!-- @if (!isLoggedIn) {
          @for (p of publicPages; track p; let i = $index) {
            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                <ion-icon aria-hidden="true" slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
        } -->
          @if (isLoggedIn) {
          <!-- @if (superUserLogin) {
            @for (p of superUserPages; track p; let i = $index) {
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                  <i class="{{p.icon}}"></i> &nbsp;
                  <ion-label>{{ p.title }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
            }
          }
          @if (isIQACADMIN && !isIQACCOADMINOnly && !onlyCollegeAdminAllowed && subscriptionStatus != 'ONBOARDED') {
            @for (p of appPagesIQAC; track p; let i = $index) {
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                  <i class="{{p.icon}}"></i> &nbsp;
                  <ion-label>{{ p.title }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
            }
          }
          @if (isIQACCOADMINOnly) {
            @for (p of appPagesIQACCoAdmin; track p; let i = $index) {
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" [routerLink]="[p.url]" lines="none" detail="false" routerLinkActive="selected">
                  <i class="{{p.icon}}"></i> &nbsp;
                  <ion-label>{{ p.title }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
            }
          }
           -->

          <!-- <div class="d-flex ms-2">
            <ion-button color="danger" fill="clear">

              <i class="fas fa-sign-out-alt color-brand-danger"></i>&nbsp;&nbsp;&nbsp; Logout</ion-button>
          </div> -->

          <div class="d-flex ms-2">
            <ion-button color="danger" fill="clear" (click)="confirmLogout()">
              <i class="fas fa-sign-out-alt color-brand-danger"></i>&nbsp;&nbsp;&nbsp; Logout
            </ion-button>
          </div>


          <ion-action-sheet trigger="open-action-sheet" header="Action" [buttons]="actionSheetButtons"
            class="eas-custom-action-sheet" (didDismiss)="logResult($event)"></ion-action-sheet>
          <!-- <ion-menu-toggle auto-hide="false">
            <ion-item
              routerDirection="root"
              data-toggle="modal"
              data-target="#logoutModal"
              lines="none"
              detail="false"
              routerLinkActive="selected"
            >
              <i class="fas fa-sign-out-alt color-brand-danger"></i>
              &nbsp;&nbsp;&nbsp;
              <ion-label class="color-brand-danger">Logout</ion-label>
            </ion-item>
          </ion-menu-toggle> -->
          }
        </ion-list>
        <div class="d-flex ms-1 p-3 justify-content-center">
          <p>{{ app_version }}</p>
        </div>
        <!-- <ion-accordion value="second">
          <ion-item slot="header" color="light">
            <ion-label>Second Accordion</ion-label>
          </ion-item>
          <div class="ion-padding" slot="content">Second Content</div>
        </ion-accordion>
        <ion-accordion value="third">
          <ion-item slot="header" color="light">
            <ion-label>Third Accordion</ion-label>
          </ion-item>
          <div class="ion-padding" slot="content">Third Content</div>
        </ion-accordion> -->

        <!-- <ion-list id="labels-list">
          <ion-list-header>Labels</ion-list-header>

          @for (label of labels; track label) {
            <ion-item lines="none">
              <ion-icon aria-hidden="true" slot="start" ios="bookmark-outline" md="bookmark-sharp"></ion-icon>
              <ion-label>{{ label }}</ion-label>
            </ion-item>
          }
        </ion-list> -->
      </ion-content>
      <blockquote class="blockquote text-center bg-dark p-1 mb-0">
        <footer class="copyright text-black-50">
          © 2025 Copyright EASIE. All Rights Reserved
        </footer>
      </blockquote>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>

<!-- Modal -->
<!-- <div
  class="modal fade"
  id="logoutModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">Confirm Logout?</div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-dark bg-brand-light"
          data-dismiss="modal"
        >
          Close <i class="fas fa-times"></i>
        </button>
        <button
          type="button"
          class="btn bg-brand-danger text-white"
          (click)="logout()"
          data-dismiss="modal"
        >
          Logout <i class="fas fa-sign-out-alt"></i>
        </button>
      </div>
    </div>
  </div>
</div> -->